<template>
<div v-show="items.length">
    <v-card class="d-flex justify-sm-space-between justify-space-around pl-1" elevation="0" tile light>
        <v-card v-for="it in sliderCols" :key="it" elevation="0" tile light :height="hidePrice ? 355 : 440" width="100%">
            <v-hover v-slot:default="{ hover }" open-delay="200" v-if="items[id(i,it)]">
                <v-card tile :height="hidePrice || contactInfo.isGuest ? (contactInfo.isGuest ? '400px' : '340px') : (hover ? '100%' : '392px')" width="96%" :class="`mt-1 text-center ` + (hover ? 'opencard' : '')" :elevation="hover ? 6 : 2" :to="productPatch(id(i,it))">
                    <v-card flat tile>
                        <v-card-subtitle dense class="pa-0 ">
                            <v-list three-line class="pa-0">
                                <v-list-item class="px-3 white">
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="product-title align-start text-left font-weight-bold link--text" :title="items[id(i,it)].name_ukr" v-text="items[id(i,it)].name_ukr"></v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-subtitle>
                        <v-card class="pa-0" elevation="0">
                            <v-overlay v-if="!bonus && items[id(i,it)].is_promo_action" absolute z-index="1" opacity="0" width="100%" class="overlay-prod caption pa-1 mx-2 d-flex align-end justify-between">
                                <v-alert v-ripple border="left" height="50" dense color="accent" class="d-flex align-center justify-center primary--text body-2 py-1 mb-1 mx-0">
                                    {{items[id(i,it)] && actionText(items[id(i,it)])}}
                                </v-alert>
                            </v-overlay>
                            <v-img height="200" width="200" :src="items[id(i,it)].bigimg" :lazy-src="nophoto" class="mx-auto"></v-img>
                        </v-card>
                        <div class="pa-3 py-1 caption">
                            Код: {{items[id(i,it)].typhoon_id}}
                        </div>
                        <v-card tile v-if="!hidePrice" :class="`px-1 ` + ((items[id(i,it)].is_promo_action) ? '':(bonus ? '':'pt-1'))" elevation="0">
                            <v-card v-if="contactInfo.isGuest" tile elevation="0" height="56" class="d-flex flex-column align-end justify-end mt-4 pb-2 px-2">
                                <div class="caption grey--text text-right mb-n2">РРЦ:</div>
                                <div :class="`headline font-weight-bold link--text `">{{items[id(i,it)].price_rrc.toLocaleString('ru-RU')}} <span class="body-2">₴</span></div>
                            </v-card>
                            <v-card-actions v-if="!contactInfo.isGuest" class="d-flex justify-space-between align-end pb-0">
                                <v-card tile elevation="0" height="56" class="d-flex flex-column align-start justify-end pb-2">
                                    <div v-if="items[id(i,it)].price_uah < items[id(i,it)].price_uah_without_action && items[id(i,it)].is_actions" class="grey--text" style="text-decoration: line-through">{{items[id(i,it)].price_uah_without_action.toLocaleString('ru-RU')}} <span class="body-2">₴</span></div>
                                    <div :class="`headline font-weight-bold ` + ((items[id(i,it)].price_uah != items[id(i,it)].price_uah_without_action && items[id(i,it)].is_promo_action) ? 'third--text' : '') ">{{items[id(i,it)].price_uah.toLocaleString('ru-RU')}} <span class="body-2">₴</span></div>
                                </v-card>
                                <v-btn :class="hover ? 'd-none' : ''" x-large icon @click.prevent.stop="addToShoppingCart(items[id(i,it)])">
                                    <v-icon v-if="!items[id(i,it)].cnt > 0" color="accent2">mdi-cart-outline</v-icon>
                                    <v-badge color="accent2" class="item-cnt" v-if="items[id(i,it)].cnt > 0">
                                        <template v-slot:badge><span>{{inShoppingCart[items[id(i,it)].typhoon_full_id]}}</span>
                                        </template>
                                        <v-icon color="accent2">shopping_cart</v-icon>
                                    </v-badge>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                        <v-expand-transition v-if="!hidePrice && !contactInfo.isGuest">
                            <v-card-actions v-if="hover" class="transition-fast-in-fast-out d-flex justify-space-between px-3 pt-0 mt-n2">
                                <div>
                                    <v-card tile elevation="0" height="20">
                                        <div v-if="items[id(i,it)].act_qty > 1 && items[id(i,it)].single_act_cond && items[id(i,it)].is_promo_action && !items[id(i,it)].is_priceoff && !items[id(i,it)].typhoon_check_lot" class="caption orange--text text-center">Кратно {{items[id(i,it)].act_qty}} шт.</div>
                                        <div v-else>
                                            <div v-if="items[id(i,it)].pack > 1 && !items[id(i,it)].is_du && !items[id(i,it)].is_priceoff" class="caption orange--text text-center">Кратно {{items[id(i,it)].pack}} шт.</div>
                                        </div>
                                    </v-card>
                                    <v-btn x-medium icon @click.prevent.stop="minus(items[id(i,it)])">
                                        <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                    <input v-model="items[id(i,it)].cnt" @click.prevent.stop="" @change="recalcMultipack(items[id(i,it)])" class="inp-cnt">
                                    <v-btn x-medium icon @click.prevent.stop="plus(items[id(i,it)])">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </div>
                                <div>
                                    <v-card tile elevation="0" height="20">
                                        <div v-if="inShoppingCart[items[id(i,it)].typhoon_full_id] > 0" class="caption accent2--text text-right">Товар вже у кошику</div>
                                    </v-card>
                                    <v-btn color="accent2" class="white--text" @click.prevent.stop="addToShoppingCart(items[id(i,it)])">
                                        <v-icon v-if="inShoppingCart[items[id(i,it)].typhoon_full_id] > 0" color="white">mdi-cart</v-icon>
                                        <v-icon v-if="!(inShoppingCart[items[id(i,it)].typhoon_full_id] > 0)" color="white">mdi-cart-outline</v-icon>
                                        Купити
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-expand-transition>
                    </v-card>
                </v-card>
            </v-hover>
        </v-card>
    </v-card>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'

export default {
    props: {
        items: Array,
        title: String,
        i: Number,
        sliderCols: Number,
        totalSlides: Number,
        'hide-price': Boolean,
        loading: Boolean,
        bonus: Boolean,
    },
    data() {
        return {
            nophoto: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAD6CAMAAAC/MqoPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTA1QkU0RUY3NTI4MTFFQkIyNzVDNzM0MTc2Mzk4RTQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTA1QkU0RjA3NTI4MTFFQkIyNzVDNzM0MTc2Mzk4RTQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFMDVCRTRFRDc1MjgxMUVCQjI3NUM3MzQxNzYzOThFNCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFMDVCRTRFRTc1MjgxMUVCQjI3NUM3MzQxNzYzOThFNCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pu9veCgAAAAYUExURevr69PT0+Pj4/T09Nra2svLy/z8/P///8CzSgsAAAAIdFJOU/////////8A3oO9WQAABZVJREFUeNrs3OuaojAMBuAcarz/O15Q1xHlkKYl4MzHPvPP9eE1IU0LlK5/9iDQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQsw5VklKY+TIefGEuRYjMfjPdBvQdPHuwkNpvpCuVi+MopL+KbroW7c/o5wQ/gV7lfuq/n25U7X7oyb6abnJpOHYOPZ0Wvjt+R3oz/Ia3b6SXDnLW6x+li13/Jp2/tsy10svOo9t56bs3W2el8/7t3EnpJaGL70ufTLrl3PK+dJ2kqfQe07ToWek6rU0Uls+fKXeufR2/i97OmnqWduXudZ+6yid07RdzLRspcSj9HuPyWvN6yaczQDkb/XF23EqX5VzvbaeeMR+O19rMPUa1mUm/nIn+U9G0qadh2wp5x1rX5Vt0/qykvXulHft76iuf1Lnq0e1dbsX7yYPo9pqTLXWOPMneb3bTTn8LTbzOFb98riocQJfl0JWWEkeRbjeVTiunRA0XOoX63Uz6x/XMwVZWKuXtpa6VXlbPiKPpLqH2J5VO6+GTYLpTeKKTRp8bvkIZXwLy1pSnzuk+PSH3yG4R+cdwmEinzTyUQI3TeBOURrf5Klaf8ZMapxzvBdLotH0JGtcGz6paQDmGbp5LUGpjVznTtUPo4jkfrQx67WxPjqCb73xKVeTqlzL1ALr4MlhrAmf1a1qSTzfv+XBF0CM3bDSdLt7CRf6+JLRyL9n0jdQkf9i1Jd1bijx1HtNnzoe8I1vw/iQl00tFGrLvg8EbVZPuMYGuNdVHfZ8LP4qgqfTt3Cy+FOHmoIcLXZDOVZegq/vhMD04iaGd8n16QrKdrOEHEcIZTzvlu7NL4w5Bj2Y87ZXvvkonPYIerPG0V777Up6ay3s840N0b4jKZspbc3mPZ3yI7g4RbWQK9wl6bH2S9rvU3zKRVk7ZLo2HJdErsvP1ZrAsZwW10jWJTrF2Y3o3movI86lIbqVTEr1qhvVyZ+yn1L29xKet8tDFHvq5OHhW9yX28vEGm2nrawOcVeasBEceXXwUpBVvSfTKwL/al1/koew6F16gku4dh3JunYsvRtekqOxwHR1Ir8p63wtrDXbJpde8plxa7Dw2AUSkw7/hECnM7aNb4wMlfrzvIb/3Wc5g1vkX+d92f+B0egXeV4NfuhuWzVfY7bkNxBF0L96bkY+Ro7jf3L/vBpFDn3nvSKVbzzGmfKndsWDQp9Bn6/VW6P0VmCRpj5IQfX4jidXtONI33NmLPuIXEm+Px7zORR80C/OQ2a139FfRF/FjzS0dH/K67Vp137bqdty2rFI7lD6W4pURd+i5mvN9/JalHqk0+tvoWzvn2C1eHLsFbrS9jVGR1MeI3nvNXfbSMPJOZcKbNrXTbxd9X33tglXs1w/QpedPP1skzztpnY9JH31gm7Lc6ctCQjbuFGdRd+58ffFqDA45ptS0Jpu6SrNSikpd9McWaDXcpQw9jJrZdfgbGhz6/Hzy2txqHebi2CVz2vjMX0MLm02+pUkyfVyS3rg4x1W1/xH7+V+PyJWtK3tr3v5SHCybXtN63LaMHf7chcu3XvHQX/PpDePR6s9Usafq2ADxMfTu+voOQekwetuYvFdfmERfXqWoakwocU2j885jn6sUfrZo7gLeDpuujSNuXfI3rzqche5sVvyNz5fRn80L/V9Xe2lzxuW1Putr56Wf+gAddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQcddNBBBx100EEHHXTQQQf97x3/BBgAHt9jjPAuObcAAAAASUVORK5CYII=',
            f: 0,
            hover: false,
            shoppingCart: [],
            inShoppingCart: {},
            giftsData: {}
        }
    },
    methods: {
        ...mapActions(['touch', 'getShoppingCartData', 'setShoppingCartData']),
        id(i, it) {
            const id = (i - 1) * this.sliderCols + it - 1
            return id
        },
        productPatch(id) {
            return this.items[id] ? '/product/' + this.items[id].typhoon_id : undefined
        },
        plus(item) {
            item.cnt = Number(item.cnt)
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot) {
                item.cnt = item.cnt + item.act_qty
                item.cnt = item.cnt - item.cnt % item.act_qty
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff) {
                item.cnt = item.cnt + item.pack
                item.cnt = item.cnt - item.cnt % item.pack
            } else {
                item.cnt++
            }
        },
        minus(item) {
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot) {
                item.cnt = item.cnt - item.act_qty
                if (item.cnt <= 0) item.cnt = 0
                item.cnt = item.cnt - item.cnt % item.act_qty
                if (item.cnt == 0 && item.cntIn > 0) item.cnt = item.act_qty
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff) {
                item.cnt = item.cnt - item.pack
                if (item.cnt <= 0) item.cnt = 0
                item.cnt = item.cnt - item.cnt % item.pack
                if (item.cnt == 0 && item.cntIn > 0) item.cnt = item.pack
            } else {
                if (item.cntIn > 0 && --item.cnt < 1) {
                    item.cnt = 1
                }
                if (item.cntIn == 0 && --item.cnt < 0) {
                    item.cnt = 0
                }
            }
        },
        recalcMultipack(item) {
            item.cnt = Number(item.cnt)
            // Если колво/В уп (шт) имеет остаток, то колво = В уп (шт.) * (целое от (колво/В уп (шт)) + 1)
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && item.cnt % item.act_qty && !item.typhoon_check_lot) {
                item.cnt = item.act_qty * (Number.parseInt(item.cnt / item.act_qty) + 1)
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff && item.cnt % item.pack) {
                item.cnt = item.pack * (Number.parseInt(item.cnt / item.pack) + 1)
            }
        },
        getLocalStorage(f) {
            let value = ''
            try {
                value = localStorage[f] ? JSON.parse(localStorage[f]) : ''
            } catch (error) {
                console.error(error)
                return ''
            }
            return value
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },

        async addToShoppingCart(item) {
            if (item.cnt == 0) {
                this.plus(item)
            }
            try {
                const scObj = await this.getShoppingCartData() || {}
                this.shoppingCart = scObj.data || []
                this.giftsData = scObj.gifts_data || {}
            } catch (error) {
                console.error(error)
            }
            let exists = false
            for (let i in this.shoppingCart) {
                if (item.typhoon_full_id == this.shoppingCart[i].typhoon_full_id) {
                    exists = true
                    this.inShoppingCart[item.typhoon_full_id] = item.cnt
                    this.$set(this.shoppingCart[i], 'cnt', item.cnt)
                }
            }
            if (!exists) {
                this.shoppingCart.push(item)
            }
            this.setShoppingCartData({shoppingCart: this.shoppingCart, giftsData: this.giftsData})
                .then(() => {
                    this.$store.commit('setShoppingCartCounter', this.shoppingCart.length)
                    this.$store.commit('setShoppingCartDialog', true)
                    this.$store.commit('setShoppingCartDialogTab', 0)
                })
        },
        async getShoppingCart() {
            let shoppingCart = []
            try {
                const scObj = await this.getShoppingCartData() || {}
                shoppingCart = scObj.data
                this.giftsData = scObj.data || {}
            } catch (error) {
                console.error(error)
            }
            const sc = {}
            const curList = this.items
            for (let item of shoppingCart) {
                sc[item.typhoon_full_id] = item.cnt
            }
            for (let i in curList) {
                curList[i].cnt = sc[curList[i].typhoon_full_id] || 0
                // this.inShoppingCart[curList[i].typhoon_full_id] = curList[i].cnt
                this.$set(this.inShoppingCart, curList[i].typhoon_full_id, curList[i].cnt)
            }
            this.items = curList
        },
        goUrl(url) {
            window.open(url, "_blank")
            //  window.location = url
        },
        actionText(item) {
            let text = ''
            const checkLotText = item.typhoon_check_lot ? 'від ' : ''
            if (item.is_spec_action){
                if (item.act_qty == 1) {
                    text = `Купи за супер ціною!`
                } else {
                    if (item.single_act_cond) {
                        text = `Купи ${checkLotText}${item.act_qty} шт. за супер ціною!`
                    } else {
                        text = `Купи з асортименту ${checkLotText}${item.act_qty} шт. за супер ціною!`
                    }
                }
            } else if (item.is_gift_action) {
                if (item.act_qty == 1) {
                    text = `Купи та отримай подарунок!`
                } else {
                    if (item.single_act_cond) {
                        text = `Купи ${checkLotText}${item.act_qty} шт. та отримай подарунок!`
                    } else {
                        text = `Купи з асортименту ${checkLotText}${item.act_qty} шт. та отримай подарунок!`
                    }
                }
            } 
            return text
        },

    },
    computed: {
        contactInfo() {
            return this.$store.state.main.contactInfo
        }
    },
    created() {
        this.getShoppingCart()
    },
    watch: {
        '$store.state.main.shoppingCartDialog'(v) {
            this.getShoppingCart()
        }
    },
}
</script>

<style>
.inp-cnt {
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid #ccc;
    width: 20%;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box
}

.item-cnt .v-badge__badge {
    top: -10px;
    right: 10px;
}

.v-list--two-line .v-list-item .v-list-item__subtitle.product-title,
.v-list-item--two-line .v-list-item__subtitle.product-title {
    -webkit-line-clamp: 3;
    line-clamp: 3;
}

.opencard {
    z-index: 2;
}

.overlay-prod .v-overlay__content {
    width: 100%;
}
</style>
